import React from 'react';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import { WhatsButton } from '../../components';
import './header.css';
// acredito que seja mais organizar o conteúdo e ajustar o estilo
// e as mudanças de responsividade, tem tudo pra ser uma dorzinha de cabeça
// import headerImg from '../../assets/header-img.webp';
// fazer o esquema dos nove anos dinâmico também conforme o atual atual
import headerImg from '../../assets/header3.png';

const Header = () => {

  return (
    <div className="psico__header header__padding" id="home">
      <div className="psico__header-content">
        <AnimationOnScroll animateIn="fade-in-bottom" animateOnce="true" duration={0.8}>
          <h1>Psicólogo André Parreira</h1>
          <p id="texto-aumentado"><b>Especialista em Relacionamento Amoroso/Familiar, Ansiedade Emocional e Autovalorização </b><br /><br />Experiência que gera Transformação Real: Com mais de <strong>9 anos de prática clínica e +400 vidas transformadas</strong></p>
          {/* <p>+10 anos ajudando pessoas!</p> */}
          {/* <p id="header-online">Experiência que gera Transformação Real: Com mais de 9 anos de prática clínica e +400 vidas transformadas</p> */}
          <p>Terapia 100% Online</p>
        </AnimationOnScroll>

        <AnimationOnScroll animateIn="fade-in-bottom" animateOnce="true" duration={0.8}>
          <div className="psico__header-content__message">
            <WhatsButton message="Agende Sua Consulta!" />
          </div>
        </AnimationOnScroll>
      </div>

      <div className="psico__header-image">
        <AnimationOnScroll animateIn="fade-in-bottom" animateOnce="true" duration={0.8} offset={0}>
          <img src={headerImg} alt="Foto do profissional André Parreira." style={{ display: 'block', height: '100%', margin: 0 }} />
        </AnimationOnScroll>
      </div>
    </div>
  )
}

export default Header
